var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiosks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.572,
    height: 23.199,
    viewBox: "0 0 12.572 23.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-522.858 -392.927)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M531.813,411.9V399.505h.989a.6.6,0,0,0,.6-.6v-5.379a.6.6,0,0,0-.6-.6h-7.317a.6.6,0,0,0-.6.6V398.9a.6.6,0,0,0,.6.6h.99v12.39c-1.465.211-3.617.74-3.617,2.025,0,1.742,3.951,2.206,6.286,2.206s6.286-.464,6.286-2.206C535.43,412.647,533.343,412.114,531.813,411.9Zm-5.728-13.59v-4.18H532.2v4.18h-.389v-2.385a.6.6,0,0,0-.6-.6h-4.138a.6.6,0,0,0-.6.6v2.385Zm1.59,8.721V396.521h2.938v10.506Zm2.938,1.2v5.093h-2.938v-5.093Zm-1.469,6.7c-3.272,0-4.947-.74-5.094-.966.055-.115.641-.568,2.425-.848v.807a.6.6,0,0,0,.6.6h4.138a.6.6,0,0,0,.6-.6v-.81a5.561,5.561,0,0,1,2.424.768C534.09,414.187,532.416,414.927,529.144,414.927Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiosks);
export default __webpack_public_path__ + "static/media/kiosks.f707394302a64ddb24dbcabf0a647b34.svg";
export { ForwardRef as ReactComponent };